// @flow

import { type WebsiteChatConfig } from '@chatchamp/chatchamp-types'

import { Channel } from '../../main/models'

import type { RootState, WidgetTab } from './rootState'

export const mutations = {
  setChannel (state: RootState, channel: Channel) {
    state.channel = channel
  },
  setCustomWebsiteChatConfig (state: RootState, customWebsiteChatConfig: $Shape<WebsiteChatConfig>) {
    state.customWebsiteChatConfig = customWebsiteChatConfig
  },
  setWsReadiness (state: RootState, isReady: boolean) {
    state.isWsReady = isReady
  },
  setIsTypingEnabled (state: RootState, isTypingEnabled: boolean) {
    state.isTypingEnabled = isTypingEnabled
  },
  setParentUrl (state: RootState, parentUrl: string) {
    state.parentUrl = parentUrl
  },
  setChatbotPayload (state: RootState, chatbotPayload: string) {
    state.chatbotPayload = chatbotPayload
  },
  setScrollPercent (state: RootState, scrollPercent: number) {
    state.scrollPercent = scrollPercent
  },
  setProductAddingToCart (state: RootState, productId: ?string) {
    state.productAddingToCart = productId
  },
  setRoutineAddingToCart (state: RootState, value: boolean) {
    state.routineAddingToCart = value
  },
  addProductToCart (state: RootState, productId: string) {
    state.cartProducts.push(productId)
  },
  setCurrentTab (state: RootState, tab: WidgetTab) {
    state.currentTab = tab
  }
}
